import axios from 'axios'
// import store from '@/store'
// import storage from 'store'
// import router from '@/router/index.js'
import router from '@/router'
import cookie from './cookie'
// import message from 'ant-design-vue/lib/message/index';
import notification from 'ant-design-vue/es/notification'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
// 发送请求时携带cookie
// axios.defaults.withCredentials = true;
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: "/api",
  timeout: 120000, // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  // console.log('error', error.data.Status);
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    // const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: '登录失效',
        description: '请重新登录'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  //   const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  //   if (token) {
  //     config.headers['Access-Token'] = token
  //   }
  // message.loading("加载中...", 1);

  return config
}, errorHandler)

request.interceptors.response.use((response) => {
  // 验证用户权限
  if (response.data.Status == 400) {
    // notification.error({
    //         message: response.data.Data,
    //     })
    // 例如apry通过路由访问apjg页面，会被服务器过滤器拦截，返回页面400，页面拦截后回到登录页，需要清除apry和apjg的cookie重新登陆
    cookie.clearCookie("apryPassport");
    cookie.clearCookie("adminPassport");
    router.push({
      path: '/',
    })
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js